import { createAction } from '@reduxjs/toolkit'

import type { TAlertData } from 'redux/reducers/Applications/Alert'

// setAlert
export const set = createAction<TAlertData>('set_alert')

// resetAlert
export const reset = createAction('reset_alert')
